/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deft_Bronze_Rat_LiftInputs */

const en_deft_bronze_rat_lift = /** @type {(inputs: Deft_Bronze_Rat_LiftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Roles`)
};

const de_deft_bronze_rat_lift = /** @type {(inputs: Deft_Bronze_Rat_LiftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rollen`)
};

/**
* | output |
* | --- |
* | "Roles" |
*
* @param {Deft_Bronze_Rat_LiftInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const deft_bronze_rat_lift = /** @type {((inputs?: Deft_Bronze_Rat_LiftInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deft_Bronze_Rat_LiftInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deft_bronze_rat_lift(inputs)
	return de_deft_bronze_rat_lift(inputs)
});